module.exports = __webpack_public_path__ + "assets/img/yzzx_anru_m_video.0cd7eb07.png";